<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="mt-4" v-if="cargando">
      <b-button variant="primary" disabled>
        <b-spinner small></b-spinner>
        Cargando...
      </b-button>
    </div>

    <div class="mt-4" v-else>
      <b-form v-on:submit.prevent="traerPtiPaciente">
        <b-row class="text-left">
          <b-col>
            <b-form-group v-if="$localStorageService.can('AS_01_ver_clinica')">
              <label>Clínica: *</label>
              <b-input-group>
                <b-input-group-prepend is-text>
                  <span><em class="fa fa-hospital-o"></em></span>
                </b-input-group-prepend>
                <b-form-select
                  v-model="clinicaSeleccionada"
                  :options="listaClinica"
                  value-field="idClinica"
                  text-field="strNombre"
                  :state="clinicaSeleccionada != null"
                  required
                >
                </b-form-select>
              </b-input-group>
              <b-form-invalid-feedback :state="clinicaSeleccionada != null">
                El campo es requerido
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <label>Fecha inicio: *</label>
            <b-form-datepicker
              v-model="fechaInicio"
              placeholder="Selecciona una fecha"
              :state="fechaInicio != null"
            ></b-form-datepicker>
            <b-form-invalid-feedback :state="fechaInicio != null">
              El campo es requerido
            </b-form-invalid-feedback>
          </b-col>
          <b-col>
            <label>Fecha fin: *</label>
            <b-form-datepicker
              v-model="fechaFin"
              placeholder="Selecciona una fecha"
              :state="fechaFin != null"
            ></b-form-datepicker>
            <b-form-invalid-feedback :state="fechaFin != null">
              El campo es requerido
            </b-form-invalid-feedback>
          </b-col>
        </b-row>

        <b-row
          class="mb-4"
          v-if="$localStorageService.can('PL_01_id_plan_boton')"
        >
          <b-col>
            <b-button type="submit" variant="outline-primary">
              Buscar
            </b-button>
          </b-col>
        </b-row>
      </b-form>

      <b-button class="mb-4" variant="primary" disabled v-if="buscando">
        <b-spinner small></b-spinner>
        Cargando...
      </b-button>

      <div v-else>
        <div v-if="campos.length === 0">
          <b-alert variant="danger" show>No existen datos</b-alert>
        </div>

        <b-table
          thead-tr-class="columnas"
          :fields="titulos"
          :items="campos"
          :per-page="registrosPorPagina"
          :current-page="paginaActual"
          responsive
          v-else
        >
          <template v-slot:cell(acciones)="row">
            <div class="alignIcon">
              <b-form-select
                v-model="row.item.nuevoPlan"
                :options="row.item.planPaciente"
                value-field="idPlan"
                text-field="nombrePlan"
              >
              </b-form-select>

              <b-button
                class="ml-4"
                variant="primary"
                disabled
                v-if="row.item.enviando"
              >
                <b-spinner small></b-spinner>
              </b-button>

              <b-button
                class="ml-4"
                variant="outline-primary"
                v-on:click="guardarPlanPti(row.item)"
                v-else
              >
                Guardar
              </b-button>
            </div>
          </template>
        </b-table>

        <b-pagination
          v-if="campos.length > 1"
          align="center"
          v-model="paginaActual"
          :total-rows="campos.length"
          :per-page="registrosPorPagina"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdministracionPtiPlan",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    listaClinica: [],
    clinicaSeleccionada: null,
    fechaInicio: null,
    fechaFin: null,
    buscando: false,
    titulos: [
      { key: "nombrePaciente", label: "Nombre del paciente" },
      { key: "idPti", label: "Pti" },
      { key: "nombrePlan", label: "Plan" },
      { key: "acciones", label: "Acciones" },
    ],
    campos: [],
    registrosPorPagina: 10,
    paginaActual: 1,
    cargando: true,
  }),
  created() {
    this.clinicaSeleccionada = this.$localStorageService.getIdClinica();
    this.obtenerClinicas();
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    obtenerClinicas() {
      const url = this.$api + "catalogos/listaClinicas";
      this.$http.get(url).then((response) => {
        if (response.data.data) {
          response.data.data.unshift({
            idClinica: null,
            strNombre: "Clínica:",
          });
          this.listaClinica = response.data.data;
          this.cargando = false;
        }
      });
    },
    traerPtiPaciente() {
      if (!this.validarFechas()) {
        const parametros = {
          idClinica: this.clinicaSeleccionada,
          fechaInicio: this.$global.traerFecha(this.fechaInicio),
          fechaFin: this.$global.traerFecha(this.fechaFin),
        };

        this.buscando = true;
        const url = this.$api + "pti/planes";

        this.$http
          .post(url, parametros)
          .then((response) => {
            if (response.data.data) {
              response.data.data = response.data.data.map((e) => ({
                enviando: false,
                ...e,
              }));
              this.campos = response.data.data;
            }
          })
          .finally(() => {
            this.buscando = false;
          });
      }
    },
    validarFechas() {
      let error = false;
      if (this.fechaInicio == null || this.fechaFin == null) {
        this.$swal({
          icon: "warning",
          text: "Coloca todas las fechas",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        error = true;
      }

      return error;
    },
    guardarPlanPti(plan) {
      plan.enviando = true;

      const parametros = {
        idPti: plan.idPti,
        nuevoPlan: plan.nuevoPlan,
        idUsuarioLogueado: this.$localStorageService.getIdUsuario(),
      };
      const url = this.$api + "pti/planes";

      this.$http
        .put(url, parametros)
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              text: "Datos actualizados correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          }
        })
        .catch((err) => {
          this.errorEnvio(err);
        })
        .finally(() => {
          plan.enviando = false;
        });
    },
  },
  notifications: {
    errorEnvio: {
      type: "error",
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>